<template>
  <div
    class="row row-item-transparent-with-border m-0"
    @click="$emit('click', id)">
    <div class="col-10 text-left column">
      <span class="input-group-text"><slot/></span>
    </div>
    <div class="col-2 chevron column justify-content-end">
      <i class="fas fa-chevron-right"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextSelector',
  components: {},
  props: {
    id: {
      type: Number,
      default: null,
    },
    borderBottom: {
      type: Boolean,
      default: false,
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.column {
  display: flex;
  align-items: center;
}

.chevron {
  color: $primary;
}

.row-item-transparent-with-border {
  cursor: pointer;
}
</style>
